import React from 'react'
import shortid from 'shortid'
import values from 'mout/object/values'
import convertToAnswerLetters from '../../../../helpers/assessment/convertToAnswerLetters'
import sortByPropText from '../../../../helpers/content/manageSets/sortByPropText'

export default function AnswerMapRow({studentScore, subtest, answers, page}) {
  const { bySubtest, byItem } = studentScore.scoring
  const scale = bySubtest[subtest.setId].scale
  const answersByItem = studentScore.answersByItem ? studentScore.answersByItem[subtest.setId] : studentScore.answersByItem
  let itemsList = sortByPropText(values(byItem[subtest.setId]), 'index')
  if (itemsList.length > 40 && page === 1) {
    itemsList = itemsList.slice(0, 40)
  } else if (itemsList.length > 40 && page === 2) {
    itemsList = itemsList.slice(40)
  }

  return (
    <tr className="studentData">
      <td className="name">{studentScore.fullName}</td>
			<td className="score">{scale}</td>
      {
        itemsList.map((item, n) => {
          const yourAnswer = answersByItem ? answersByItem[item.itemId] : ''
          return <td 
            className={yourAnswer === answers[n] ? 'correct' : 'incorrect'}
            key={shortid.generate()}
          >
            {yourAnswer ? convertToAnswerLetters(n + 1, yourAnswer) : '-'}
          </td>
        }
        )
      }
    </tr>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/StudentAnswerMap/AnswerMapRow.js